export default "__VITE_ASSET__08d94d1c__"